export const SDK_VERSION = '0.1.2'
